export default {
    getTourGuides: state => state.tourGuides,
    getLoadingStatus: state => state.loading,
}